var moduleMap = {
	"./RemoteButtonNavigation": () => {
		return Promise.all([__webpack_require__.e(814), __webpack_require__.e(726), __webpack_require__.e(994), __webpack_require__.e(352), __webpack_require__.e(925), __webpack_require__.e(483)]).then(() => (() => ((__webpack_require__(8483)))));
	},
	"./CustomForm": () => {
		return Promise.all([__webpack_require__.e(814), __webpack_require__.e(726), __webpack_require__.e(755), __webpack_require__.e(994), __webpack_require__.e(307), __webpack_require__.e(352), __webpack_require__.e(343), __webpack_require__.e(925), __webpack_require__.e(639)]).then(() => (() => ((__webpack_require__(8639)))));
	},
	"./schema": () => {
		return __webpack_require__.e(511).then(() => (() => ((__webpack_require__(511)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});